import { useAtom } from "jotai";
import { useEffect } from "react";
import { AuthContextProps, useAuth } from "react-oidc-context";
import { authTokenAtom } from "atoms";
import { fetchUserRoles } from "shared/auth/app-access";

interface IdTokenClaims {
  hasRealmRole(role: string): boolean;
}

interface OIDCLoginInformation {
  isLoggedIn: boolean;
  hasAllingaStageTTSAccess: boolean;
  token: string;
  userProfile?: IdTokenClaims;
  auth: AuthContextProps;
}

export const useOIDCLogin = (): OIDCLoginInformation => {
  const auth = useAuth();
  const [authToken, setAuthToken] = useAtom(authTokenAtom);
  let isLoggedIn = auth.isAuthenticated;

  useEffect(() => {
    if (auth.isAuthenticated) {
      setAuthToken(auth.user?.access_token || "");
    }
  }, [
    isLoggedIn,
    auth.isAuthenticated,
    auth.user?.access_token,
    auth.user?.profile,
    setAuthToken,
  ]);

  isLoggedIn &&= authToken !== "";

  const userProfile = auth.user?.profile as IdTokenClaims | undefined;

  const userRoles = authToken ? fetchUserRoles(authToken) : [];
  // should have access to AS and one of the TTS environments
  const hasAllingaStageTTSAccess =
    userRoles.includes("AllingaStage") &&
    (userRoles.includes("prod:TTS") ||
      userRoles.includes("staging:TTS") ||
      userRoles.includes("collab:TTS") ||
      userRoles.includes("dev:TTS"));

  return {
    isLoggedIn,
    hasAllingaStageTTSAccess,
    token: authToken,
    userProfile,
    auth,
  };
};
